import React from 'react';
import styles from './Hero.module.css';

const Hero = () => {
  const openOrderForm = () => {
    window.open('https://form.jotform.com/212676109824358', '_blank', 'width=650,height=743');
  };

  return (
    <section id="home" className={styles.hero}>
      <div className={styles.heroBackground}></div>
      <div className="container">
        <div className={styles.heroContent}>
          <h1 className={`${styles.heroTitle} fade-in-up`}>
            Гостиничные чеки<br />для командировки
          </h1>
          <p className={`${styles.heroSubtitle} fade-in-up`}>
            Предоставляем кассовые чеки с QR-кодом и другие документы для отчета по командировке от действующей гостиницы в Челябинске
          </p>
          <button 
            className={`btn btn-secondary ${styles.heroButton} fade-in-up`}
            onClick={openOrderForm}
          >
            Заказать чеки 24/7
          </button>
        </div>
      </div>
      <div className={styles.heroDivider}></div>
    </section>
  );
};

export default Hero;